<template>
  <div v-loading="loading" class="addition-colleagues">
    <div class="header-actions">
      <search-input
        placeholder="Поиск по ФИО"
        style="width: 300px"
        v-model="filters.search"
        @change="filtersChanged"
      >
      </search-input>
      <div slot="right">
        <div class="el-row--flex">
          <el-button
            type="primary"
            size="small"
            icon="fas fa-plus"
            @click="openAddDialog"
          >
            Добавить коллег
          </el-button>
        </div>
      </div>
    </div>
    <div class="addition_colleagues-block">
      <el-table :data="colleagues" border>
        <el-table-column prop="user.full_name" label="ФИО"></el-table-column>
        <el-table-column prop="user.email" label="Email"></el-table-column>
        <el-table-column width="300" prop="status_label" label="Статус"></el-table-column>
        <el-table-column width="90" align="center">
          <template v-slot="scope">
            <el-popconfirm
              v-if="scope.row.status === 'manage_request'"
              confirm-button-text='Да'
              cancel-button-text='Нет'
              icon="el-icon-question"
              title="Вы уверены, что хотите удалить коллегу с оценки?"
              @confirm="deleteColleague(scope.row.id, scope.row.evaluation_id)"
            >
              <el-button
                slot="reference"
                class="table-action-button"
                size="mini"
                round
                icon="far fa-trash-alt"
              >
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <paginator
        :paginator.sync="paginator"
        use-router-query-param
        @page-changed="loadColleagues"
      ></paginator>
    </div>

    <add-eval-colleagues-dialog
      ref="addDialog"
      :evaluation="evaluation"
      @load-colleagues="loadColleagues"
      @refresh-evaluatee="refreshEvaluatee"
    >
    </add-eval-colleagues-dialog>
  </div>
</template>

<script>
import Paginator from "@/components/Paginator";
import {paginator} from "@/mixins/paginator";
import SearchInput from "@/components/filters/SearchInput.vue";
import AddEvalColleaguesDialog from "@/modules/evaluation/components/myEvaluation/AddEvalColleaguesDialog.vue";

export default {
  name: "addition-colleagues",
  components: {AddEvalColleaguesDialog, SearchInput, Paginator},
  data() {
    return {
      loading: false,
      colleagues: [],
      filters: {},
    }
  },
  props: {
    evaluation: {
      type: Object,
      default: {},
    },
  },
  mixins: [paginator],
  mounted() {
    this.loadColleagues();
  },
  beforeMount() {
    this.paginator.perPage = 10;
  },
  methods: {
    openAddDialog() {
      this.$refs.addDialog.open();
    },
    loadColleagues() {
      this.loading = true;
      this.$api.evaluation.myEvaluationColleaguesSearch({
        ...this.filters,
        expand: ['user'].join(),
        evaluation_id: this.$route.params.id,
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
      })
        .then(({data, paginator}) => {
          this.colleagues = data.colleagues;
          this.paginatorFill(paginator);

          this.$emit("update-total-count", data.allEvaluationColleagues);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    deleteColleague(id, evaluationId) {
      this.loading = true;
      this.$api.evaluation.myEvaluationColleaguesDelete({
        ids: [id],
        evaluation_id: evaluationId,
      })
        .then(data => {
          this.$notify.success({
            title: 'Удалено',
            message: 'Коллега успешно удален с оценки'
          });
        })
        .finally(() => {
          this.loadColleagues();
          this.refreshEvaluatee();
        })
    },
    refreshEvaluatee() {
      this.$emit('refresh-evaluatee');
    },
    filtersChanged() {
      this.loadColleagues();
    },
  }
}
</script>

<style scoped lang="scss">
  .addition-colleagues {
    .addition_colleagues-block {
      margin: 25px 0;
    }

    .header-actions {
      display: flex;
      justify-content: space-between;
    }
  }
</style>